/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2024 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { useState } from 'react'

export const useFeature = ({
  feature,
  getFeaturePrice,
  getLicensesIdsSelected,
  keyId
}) => {
  const defaultChecked = { timestamp: Date.now(), checked: false }
  const [featureIsChecked, setFeatureIsChecked] = useState(defaultChecked)
  const [allGroupsChecked, setAllGroupsSelected] = useState(defaultChecked)
  const [featurePrice, setFeaturePrice] = useState(0)
  const [licensesGroups, setLicensesGroups] = useState({})
  const calcGroupLicenses = groupLicenses => {
    const keys = Object.keys(groupLicenses)
    let price = 0

    keys.forEach(key => {
      let currentPrice = 0

      groupLicenses[key].forEach(license => {
        if (license.checked) {
          currentPrice = +currentPrice + +license.price
        }
      })

      price = price + currentPrice
    })

    return price
  }
  const calcFeaturePrice = (licensesGroups) => {
    const groupLicensesPrice = calcGroupLicenses(licensesGroups)

    setFeaturePrice(groupLicensesPrice)
    getFeaturePrice &&
      getFeaturePrice(keyId, groupLicensesPrice)

    return groupLicensesPrice
  }
  const checkAllLicensesSelected = (licensesGroups) => {
    const keys = Object.keys(licensesGroups)
    let allSelected = true

    for (let i = 0; i < keys.length; i++) {
      const currentKey = keys[i]
      const hasFalseValue = licensesGroups[currentKey]
        .find(license => license.checked === false)

      if (hasFalseValue) {
        allSelected = false

        break
      }
    }

    setFeatureIsChecked({ timestamp: Date.now(), checked: allSelected })
  }
  const normalizeLicensesGroup = (groupId, licensesValues) => {
    return { [groupId]: licensesValues }
  }
  const filterCheckedLicenses = (licensesGroup) => {
    let result = []

    for (const key in licensesGroup) {
      const filteredIds = licensesGroup[key]
        .filter(item => item.checked)
        .map(item => item.id)

      if (filteredIds.length > 0) {
        result = [...result, ...filteredIds]
      }
    }

    return result
  }
  const processLicenses = (groupId, values) => {
    const licensesGroup = normalizeLicensesGroup(groupId, values)
    const currentGroupLicenses = { ...licensesGroups, ...licensesGroup }
    const licensesSelected = filterCheckedLicenses(currentGroupLicenses)
    getLicensesIdsSelected && getLicensesIdsSelected(keyId, licensesSelected)
    calcFeaturePrice(currentGroupLicenses)
    setLicensesGroups(currentGroupLicenses)
    checkAllLicensesSelected(currentGroupLicenses)
  }
  const onSelectFeature = (checked) => {
    const common = { timestamp: Date.now, checked }
    let licenseIds = []
    setFeatureIsChecked(common)
    setAllGroupsSelected(common)

    if (checked) {
      const groupLicenses = {}
      feature.licenseGroups.forEach(licenseGroup => {
        const licenses = licenseGroup
          .licenses
          .map(license => ({ ...license, checked }))

        groupLicenses[licenseGroup.id] = licenses
        licenseIds = [
          ...licenseIds,
          ...licenses.map(license => license.id)
        ]
      })

      setLicensesGroups(groupLicenses)
      calcFeaturePrice(groupLicenses)
    } else {
      getFeaturePrice && getFeaturePrice(keyId, 0)
      setLicensesGroups({})
      setFeaturePrice(0)
    }
    getLicensesIdsSelected && getLicensesIdsSelected(keyId, licenseIds)
  }

  return {
    allGroupsChecked,
    featureIsChecked,
    featurePrice,
    processLicenses,
    onSelectFeature
  }
}
